import IAuthState from "../../interfaces/IAuthState";
import {startSignalRHub, stopSignalRHub} from "../signalr/connector"


const loginActionType = "authStore/login";
const logoutActionType = "authStore/logout";
const reduxPersistREHYDRATE = "persist/REHYDRATE";

const afterLoginAction = () => {
    startSignalRHub();
}

const afterRehydrateAction = (store: { getState: () => { authStore: IAuthState; }; }) => {
    const { authStore } = store.getState();
    if(authStore.token){
        startSignalRHub();
    }
    
}

const beforeLogoutAction = (store: { getState: () => { authStore: IAuthState; }; }) => {
    const { authStore } = store.getState();
    stopSignalRHub();
}

const signalRMiddleware = (store: any) =>
    (next: (action: any) => any) =>
        (action: { type: string; }) => {
            try {
                switch (action.type) {
                    case logoutActionType:
                        beforeLogoutAction(store);
                        break;
                    default:
                        break;
                }
            } catch (error) {
                console.error(error);
            }

            const result = next(action);
            
            try {
                switch (action.type) {
                    case loginActionType:
                        afterLoginAction();
                        break;
                    case reduxPersistREHYDRATE:
                        afterRehydrateAction(store);
                        break;    
                    default:
                        break;
                }
            } catch (error) {
                console.error(error);
            }
            return result
        }

export default signalRMiddleware;